import React from 'react';
import { useAccessControl } from '../contexts/AccessControlContext';
import { Navigate } from 'react-router-dom';

const AccessPage: React.FC = () => {
  const { token, isValid, isExpired } = useAccessControl();

  // If we have a valid token, redirect to upload page
  if (token && isValid && !isExpired) {
    return <Navigate to="/upload" replace />;
  }

  // If token is expired, redirect to expired page
  if (token && isExpired) {
    return <Navigate to="/access-expired" replace />;
  }

  // Show minimal access page with no header
  return (
    <div className="min-h-screen bg-primary-bg flex items-center justify-center">
      <div className="text-center">
        <p className="text-white text-xl">No access, contact Insyra tech for access</p>
      </div>
    </div>
  );
};

export default AccessPage;